import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToWishlist, loadUserWishlist } from "../../redux/slices/wishlistSlice";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getProductAllList } from "../../services/ProductServices";
import { addToCart } from "../../redux/slices/cartSlice";
import toast from "react-hot-toast";
import { addProductToUserWishlist, getAllWishlist } from "../../services/WishlistService";
import { CiHeart } from "react-icons/ci";
import "./Shop.css";
import { IoMdHeart } from "react-icons/io";
import { addProductToUserCart } from "../../services/cartService";


export default function ProductList() {

  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);
  const categories = [...new Set(products.map((item) => item.categoryName))];
  const uniqueCategories = [...categories,"All"];
  const [activeTab, setActiveTab] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userId = useSelector((state) => state.auth.userId);
 // const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn);
 
  const cartItems = useSelector((state) => (userId ? state.cart.userCart :state.cart.guestCart || []));
  const wishlistItems = useSelector((state) => (userId ? state.wishlist.userWishlist : state.wishlist.wishlistItems));

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getProductAllList();
        if (response && response.length > 0) {
          setProducts(response);
          setActiveTab(response[0].categoryName);
        }
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  console.log("product",products)
   
  const truncate = (str, maxLength) => {
    return str?.length > maxLength ? str.slice(0, maxLength) + "..." : str;
  };
  const handleAddToCart = async (product) => {
    if (!userId) {
      dispatch(addToCart({ item:{...product,prodGuId:product.guid, thumbImage: product.thumbImage}, isGuest: true }));
      toast.success(`${product.name} added to cart!`)
      return;
    };
    try {
      const cartData = {
        id: product.id,
        guid: product.guid || "",
        version: 0,
        isDeleted: false,
        createdUser: userId,
        createdDate: new Date().toISOString(),
        updatedUser: userId,
        updatedDate: new Date().toISOString(),
        prodGuId: product.guid,
        quantity: 1,
        shortName: product.name || "Unnamed Product",
        retailRate: product.retailRate ?? 0,
      };
      await addProductToUserCart(cartData);
      dispatch(addToCart({ item:{...product,prodGuId:product.guid, thumbImage: product.thumbImage}, isGuest: false }));
      toast.success(`${product.name} added to cart!`);
    } catch (error) {
      toast.error("Failed to add to cart.");
    }
  }
console.log("cartItems",cartItems)
  const handleAddToWishlist = async (product) => {
    if (!userId) {
      dispatch(addToWishlist({ item: product, isGuest: true }));
      toast.success(`${product.name} added to wishlist!`);
      return;
    }
    try {
      const wishlistData = {
        id: product.id,
        guid: product.guid || "",
        version: 0,
        isDeleted: false,
        createdUser: userId,
        createdDate: new Date().toISOString(),
        updatedUser: userId,
        updatedDate: new Date().toISOString(),
        prodGuId: product.guid,
        shortName: product.name || "Unnamed Product",
        retailRate: product.retailRate ?? 0,
      };
      await addProductToUserWishlist(wishlistData);
      dispatch(addToWishlist({ item: product, isGuest: false }));
      toast.success(`${product.name} added to your wishlist!`);
    } catch (error) {
      toast.success(`${product.name} added to your wishlist!`);
    }

  };

  if (loading) return <p className="text-center">Loading products...</p>;
  if (error) return <p className="text-center">Error: {error}</p>;
//console.log(cartItems,wishlistItems,"cartitems")
  return (
    <section className="ftco-menu">
      <div className="container">
        <div className="row d-md-flex">
          <div className="col-lg-12 p-md-5">
           
            <div className="nav nav-pills justify-content-center">
              {uniqueCategories.map((category, index) => (
                <button
                  key={index}
                  className={`nav-link fw-300 text-uppercase ${activeTab === category
                    ? "active" : ""}`}
                  onClick={() => setActiveTab(category)}
                >
                  {category}
                </button>
              ))}
            </div>
            <div className="tab-content mt-5">
              <div className="tab-pane fade show active">
                <div className="row">
                  {products
                    .filter((item) => activeTab === "All" || item.categoryName === activeTab)
                    .map((item) => {
                      const isInCart = cartItems.some((cartItem) => cartItem.id === item.id);
                      console.log("isinCART",isInCart)
                      const isInWishlist = Array.isArray(wishlistItems) && wishlistItems.some((wishlistItem) => wishlistItem.id === item.id);
                     
                      return (
                        <div key={item?.guid} className="col-md-3">
                          <div className="menu-entry text-center position-relative">
                            <button
                              className={`wishlisticon ${isInWishlist ? "wishlisted" : ""}`}
                              onClick={() => handleAddToWishlist(item)}
                            >
                              {isInWishlist ? <IoMdHeart /> : <CiHeart />}
                            </button>
                            <Link className="nav-link" to={`/product/${item?.guid}`}>
                           <img
    src={`https://inventory-api.exodusvacations.in/${item.thumbImage.trim().replace(/^wwwroot\//,'')}`}
    alt={item.name} width={250} height={200}  className="img-fluid"/>
                             
                         
                             {/* <img src="/images/seracoffee-7.jpeg" alt={item.name} width={200} height={200}
                               className="img-fluid" />  */}
                            </Link>
                            <div className="text text-white pt-4">
                            <Link className="nav-link" to={`/product/${item?.guid}`}>
                             <h3>{item.name}</h3>
                            
                             <p className="p-color">{truncate(item?.shortDescription, 30)}</p>
                              <p className="price"><span>₹ {item?.retailRate}</span></p>
                              </Link>
                              <p>
                                {isInCart ? (
                                  <Link to="/cart" className="btn btn-primary btn-outline-primary rounded-0">Go to cart</Link>
                                ) : (
                                  <a onClick={() => handleAddToCart(item)}
                                    className="btn btn-primary btn-outline-primary rounded-0">
                                    Add to Cart
                                  </a>
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
